"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteConfigBySlug = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var sites_1 = require("../features/apis/sites");
var site_1 = require("../features/slices/site");
var useSiteConfigBySlug = function (slug) {
    var dispatch = (0, react_redux_1.useDispatch)();
    // RTK Query hook for MongoDB API - skip if no slug
    var _a = (0, sites_1.useGetSiteBySlugQuery)(slug, {
        skip: !slug,
    }), siteResponse = _a.data, apiError = _a.error, isLoading = _a.isLoading;
    // Get config from MongoDB
    var config = null;
    var error = null;
    if ((siteResponse === null || siteResponse === void 0 ? void 0 : siteResponse.success) && siteResponse.content) {
        config = siteResponse.content.site;
    }
    else if (apiError) {
        // Handle different types of errors
        var err = apiError;
        if (err && typeof err === "object" && "status" in err) {
            if (err.status === 404) {
                error = "Site not found for slug";
            }
            else {
                error = "Failed to load site configuration from database";
            }
        }
        else {
            error = "Failed to load site configuration from database";
        }
        console.error("Failed to load site by slug:", apiError);
    }
    // Mirror the loaded site into Redux so non-React surfaces (FaceTec
    // sample-app controller) can read tenant branding without threading
    // siteConfig through React props.
    (0, react_1.useEffect)(function () {
        if (config) {
            dispatch((0, site_1.setCurrentSite)(config));
        }
    }, [config, dispatch]);
    return {
        config: config,
        loading: isLoading,
        error: error,
    };
};
exports.useSiteConfigBySlug = useSiteConfigBySlug;
